const Typography = {
  fontFamily: "'TCCCUnity-Regular', 'Roboto', 'Arial', sans-serif",
  h1: {
    fontWeight: 700,
    fontSize: "3rem",
    fontFamily: "'TCCCUnity-Regular', 'Roboto', sans-serif",
  },
  h2: {
    fontWeight: 500,
    fontFamily: "'TCCCUnity-Regular', 'Roboto', sans-serif",
  },
  h3: {
    fontWeight: 400,
    fontFamily: "'TCCCUnity-Regular', 'Roboto', sans-serif",
  },
  h4: {
    fontWeight: 400,
    fontFamily: "'TCCCUnity-Regular', 'Roboto', sans-serif",
  },
  h5: {
    fontWeight: 300,
    fontFamily: "'TCCCUnity-Regular', 'Roboto', sans-serif",
  },
  h6: {
    fontWeight: 300,
    fontFamily: "'TCCCUnity-Regular', 'Roboto', sans-serif",
  },
  body1: {
    fontFamily: "'TCCCUnity-Regular', 'Roboto', sans-serif",
  },
  body2: {
    fontFamily: "'TCCCUnity-Regular', 'Roboto', sans-serif",
  },
  button: {
    fontFamily: "'TCCCUnity-Regular', 'Roboto', sans-serif",
    textTransform: "none",
  },
  subtitle1: {
    fontFamily: "'TCCCUnity-Regular', 'Roboto', sans-serif",
  },
  subtitle2: {
    fontFamily: "'TCCCUnity-Regular', 'Roboto', sans-serif",
  },
};

export { Typography };
